<template>
  <div class="fapq-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <div class="card-title">
            项目排期
            <div class="search-mode">
              <input type="text" class="search-input" @keyup.enter="Search" placeholder="关键字搜索" v-model="search" />
              <el-button class="search-btn" icon="el-icon-search" @click="Search"/>
            </div>
          </div>
          <div class="card-content" >
            <el-row>
              <el-col :span="5">
                <ul class="group-filter">
                  <li :class="type===0?'active':''" @click="change(0)">未排期</li>
                  <li :class="type===1?'active':''" @click="change(1)">已排期</li>
                </ul>
              </el-col>
              <el-col :span="19" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="房屋标识"
                    min-width="180"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#000;">{{scope.row.name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="客户名称"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.custname}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="联系电话"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.tel}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="地区"
                    width="150"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.province}} {{scope.row.city}} {{scope.row.county}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    width="180"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="设计师"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.designer_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="客服"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.customer_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="销售内勤"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.sales_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="项目经理"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.foreman_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="type===0" type="danger">待排期</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="type===1">已排期</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="项目排期详情"
      :visible.sync="editVisible"
      top="10vh"
      width="30%">
      <div v-loading="dloading">
        <el-form ref="editForm" :model="editForm" :rules="editRules"  label-position="right" label-width="auto" size="small">
          <el-form-item label="房屋标识" prop="name">
            <el-input
              v-model="editForm.name"
              :disabled="true">
            </el-input>
          </el-form-item>
          <div v-for="(item, index) in editForm.stageInfo" :key="item.key">
            <el-form-item :label="item.name" :prop="'stageInfo.' + index +'.day'" :rules="stageInfoRules.day">
              <i class="el-icon-remove-outline" style="color:#99a9bf" v-if="item.isfinish===0"></i>
              <i class="el-icon-success" style="color:#67C23A" v-if="item.isfinish===1"></i>
              <el-date-picker
                @change="setTime"
                v-model="item.day"
                :disabled="item.isfinish===1"
                type="date"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <el-form-item label="开工日期" prop="starttime">
            <el-date-picker
              v-model="editForm.starttime"
              :disabled="true"
              type="date"
              style="width: 100%"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
              placeholder="根据工期自动计算">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="完工日期" prop="endtime">
            <el-date-picker
              v-model="editForm.endtime"
              :disabled="true"
              type="date"
              style="width: 100%"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
              placeholder="根据工期自动计算">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :loading="editLoading" @click="submitForm('editForm')">立即提交</el-button>
        <el-button size="small" @click="editVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDelDecorationList, getDelDecorationStageList, addOrEditDecorationStage } from '@/api/dealer'
export default {
  name: 'delxmpq',
  computed: {
    user: getUser
  },
  data() {
    return {
      search: '',
      type: 0,
      loading: false,
      dloading: false,
      editLoading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editForm: {
        did: null,
        name: '',
        starttime: '',
        endtime: '',
        stageInfo: []
      },
      editRules: {
        starttime: [{ required: true, message: '请选择开工日期', trigger: 'change' }],
        endtime: [{ required: true, message: '请选择完工日期', trigger: 'change' }],
        name: [{ required: true, message: '请选择房屋', trigger: 'blur' }]
      },
      stageInfoRules: {
        day: [{ required: true, message: '请选择阶段工期', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    setTime() {
      let tempstart = null
      let tempend = null
      for (const s of this.editForm.stageInfo) {
        if (s.day !== null && s.day !== '' && s.day !== undefined) {
          if (tempstart != null) {
            const oldst = new Date(Date.parse(tempstart))
            const st = new Date(Date.parse(s.day))
            if (st < oldst) {
              tempstart = s.day
            }
          } else {
            tempstart = s.day
          }
          if (tempend != null) {
            const olded = new Date(Date.parse(tempend))
            const ed = new Date(Date.parse(s.day))
            if (ed > olded) {
              tempend = s.day
            }
          } else {
            tempend = s.day
          }
        }
      }
      this.editForm.starttime = tempstart
      this.editForm.endtime = tempend
    },
    change(n) {
      if (this.type === n) {
        return false
      }
      this.type = n
      this.getData()
    },
    Search() {
      if (this.search !== null && this.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        type: this.type,
        search: this.search,
        page: this.currentPage,
        limit: this.pageSize,
        delid: this.user.delid,
        userid: this.user.userid
      }
      getDelDecorationList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.editForm.did = row.did
      this.editForm.name = row.name
      this.editForm.starttime = row.starttime
      this.editForm.endtime = row.endtime
      this.editVisible = true
      this.dloading = true
      getDelDecorationStageList({ did: this.editForm.did }).then(response => {
        this.editForm.stageInfo = response.data
        this.dloading = false
      }).catch(() => {
        this.dloading = false
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editLoading) {
            this.editLoading = true
            let jsonStr = ''
            for (const p of this.editForm.stageInfo) {
              jsonStr += '"' + p.id + '":"' + p.day + '",'
            }
            if (jsonStr.length > 0) {
              jsonStr = '{' + jsonStr.substring(0, jsonStr.length - 1) + '}'
            }
            const data = {
              did: this.editForm.did,
              starttime: this.editForm.starttime,
              endtime: this.editForm.endtime,
              jsonStr: jsonStr
            }
            addOrEditDecorationStage(data).then(response => {
              this.$message({
                message: '项目排期提交成功',
                type: 'success'
              })
              this.editLoading = false
              this.editVisible = false
              this.getData()
            }).catch(() => {
              this.editLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fapq-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
